function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import injectStyles from '../jss';
import styles from './Loader.jss';
import { Range } from 'immutable';
export var Loader = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Loader, _React$PureComponent);
  function Loader() {
    _classCallCheck(this, Loader);
    return _possibleConstructorReturn(this, _getPrototypeOf(Loader).apply(this, arguments));
  }
  _createClass(Loader, [{
    key: "renderFluidSpinner",
    value: function renderFluidSpinner() {
      var _this$props = this.props,
        classes = _this$props.classes,
        classNameProp = _this$props.className,
        inline = _this$props.inline;
      var className = classnames(classes.fluid, inline && classes.fluid__inline, classNameProp);
      var bars = Range(0, 5).map(function (i) {
        return React.createElement("span", {
          key: i,
          className: classes.fluidBar,
          style: {
            animationDelay: ".".concat(2 * i, "s"),
            left: "".concat(11 * i, "px")
          }
        });
      }).toArray();
      return React.createElement("div", {
        className: className
      }, React.createElement("div", {
        className: classes.fluidWrapper
      }, bars));
    }
  }, {
    key: "renderSectionsSpinner",
    value: function renderSectionsSpinner() {
      var withBars = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props2 = this.props,
        classNameProp = _this$props2.className,
        classes = _this$props2.classes;
      var className = classnames(classes.section, classNameProp);
      var bars = withBars ? Range(0, 9).map(function (i) {
        return React.createElement("div", {
          key: i,
          className: classnames(classes.sectionBar, classes["sectionBar__".concat(i + 1)]),
          style: {
            transform: "rotate(-".concat(40 * i, "deg)")
          }
        });
      }).toArray() : null;
      return React.createElement("div", {
        className: className
      }, bars, React.createElement("div", {
        className: classes.sectionSpinner
      }), React.createElement("div", {
        className: classes.sectionSpinner
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var variant = this.props.variant;
      if (variant === 'fluid') {
        return this.renderFluidSpinner();
      }
      if (variant === 'sections') {
        return this.renderSectionsSpinner();
      }
      if (variant === 'circle') {
        return this.renderSectionsSpinner(false);
      }
      return null;
    }
  }]);
  return Loader;
}(React.PureComponent);
_defineProperty(Loader, "styleRoot", 'Loader');
_defineProperty(Loader, "defaultProps", {
  inline: false,
  variant: 'fluid'
});
export default injectStyles(styles)(Loader);